import { render, staticRenderFns } from "./sidebarComponent.vue?vue&type=template&id=40bbfd2d&scoped=true"
import script from "./sidebarComponent.vue?vue&type=script&lang=js"
export * from "./sidebarComponent.vue?vue&type=script&lang=js"
import style0 from "./sidebarComponent.vue?vue&type=style&index=0&id=40bbfd2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bbfd2d",
  null
  
)

export default component.exports